import Passport from 'mg-passport';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import App from './App';
import './index.less';
import * as serviceWorker from './serviceWorker';
import { pro } from './api/mode';

let host = pro ? 'https://api.mangoebike.com' : 'http://localhost:9020';
ReactDOM.render(
  <Passport host={host}>
    <App />
  </Passport>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.register();



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1-0!./src/index.tsx